// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3UX5i","buttons":"SendReceipts_buttons__dKELL","email":"SendReceipts_email__1WEfX","bookApptTitle":"SendReceipts_bookApptTitle__2zUu_"};